/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {FormState}
 */
export const formState = {
    mode: "display",
    contentOnly: {},
    reorderActive: false,
    loadingForm: false,
    modal: "forms",
    lastQuestionAdded: null,
    current: undefined,
    combineAllSteps: false,
    ignoreFieldValidation: false,
    settings: {
        isDirty: false,
        isSaving: false,
        settings: null
    }
};

/**
 * @typedef {object} FormState
 * @property {'display' | 'edit'} mode
 * @property {'forms' | 'composer'} modal
 * @property {Record<string, boolean>} contentOnly
 * @property {string | null} lastQuestionAdded
 * @property {boolean} combineAllSteps
 * @property {boolean} ignoreFieldValidation
 */
